"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Localize_1 = require("../../../gen-src/Localize");
exports.FieldDataTypeMappings = {
    BOOLEAN: Localize_1.Messages.FieldDataType_Boolean,
    DATE: Localize_1.Messages.FieldDataType_Date,
    DATETIME: Localize_1.Messages.FieldDataType_Datetime,
    INTEGER: Localize_1.Messages.FieldDataType_Integer,
    REAL: Localize_1.Messages.FieldDataType_Real,
    SPATIAL: Localize_1.Messages.FieldDataType_Spatial,
    STRING: Localize_1.Messages.FieldDataType_String,
    TUPLE: Localize_1.Messages.FieldDataType_Tuple,
    TABLE: Localize_1.Messages.FieldDataType_Table,
    UNKNOWN: Localize_1.Messages.FieldDataType_Unknown
};
exports.FieldRoleMappings = {
    DIMENSION: Localize_1.Messages.FieldRole_Dimension,
    MEASURE: Localize_1.Messages.FieldRole_Measure,
    UNKNOWN: Localize_1.Messages.FieldRole_Unknown
};
exports.FieldRoleCategoryMappings = {
    NOMINAL: Localize_1.Messages.FieldRoleCategory_Nominal,
    ORDINAL: Localize_1.Messages.FieldRoleCategory_Ordinal,
    QUANTITATIVE: Localize_1.Messages.FieldRoleCategory_Quantitative,
    UNKNOWN: Localize_1.Messages.FieldRoleCategory_Unknown
};
//# sourceMappingURL=FieldEnumPropertyMappings.js.map